import { FunctionComponent } from 'react'
import { formatDate } from '@utils/date'
import { PostedCommentingItemProps, CommentAuthorType } from './types'
import translate from '@i18n'
import AnswerIndicator from './AnswerIndicator'
import ItemContent from './ItemContent'
import ItemHeader from './ItemHeader'
import styled from 'styled-components'
import DatePublished from './DatePublished'
import TextContent from './TextContent'
import ItemSuperUserIndicator from './ItemSuperUserIndicator'
import ActionsResponding from './ActionsResponding'
import SecondaryButton from '@components/Buttons/Secondary'

const AuthorName = styled.div`
  flex: 1;
`

const ItemActions = styled.div`
  margin-top: 25px;
  display: flex;
  flex-wrap: wrap;
`

const PostedCommentingItem: FunctionComponent<PostedCommentingItemProps> = ({
  type,
  authorType,
  gender,
  deleting,
  authorName,
  datePublished,
  textContent,
  onDelete,
}) => {
  const isSuperUser = [
    CommentAuthorType.ADMIN,
    CommentAuthorType.JOURNALIST,
    CommentAuthorType.MODERATOR,
  ].includes(authorType)

  const genderCheckedAuthorType = `commenting.authorType.${authorType.toLowerCase()}${
    gender === 'female' ? '.female' : ''
  }`
  return (
    <>
      {type === 'answer' && <AnswerIndicator />}
      <ItemContent
        isOwnItem={true}
        deletingItem={deleting}
        isSuperUser={isSuperUser}>
        {isSuperUser ? (
          <ItemSuperUserIndicator
            //@ts-expect-error
            authorType={translate(genderCheckedAuthorType)}
          />
        ) : null}
        <ItemHeader>
          <AuthorName>{authorName}</AuthorName>
          <DatePublished>
            {formatDate(datePublished)
              ? (formatDate(datePublished) as any)?.dateOrTime
              : ''}
          </DatePublished>
        </ItemHeader>
        <TextContent>{textContent}</TextContent>
        <ItemActions>
          <ActionsResponding>
            <SecondaryButton onClick={onDelete} size="large">
              {translate('commenting.delete')}
            </SecondaryButton>
          </ActionsResponding>
        </ItemActions>
      </ItemContent>
    </>
  )
}

export default PostedCommentingItem
